module.exports = __webpack_public_path__ + "static/fonts/trebuchet_MS_Bold.7a5e80f.woff";